import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidator {

  static noWhiteSpace(control: AbstractControl): ValidationErrors | null {
    let crtValue = control.value;
    // if (crtValue && (crtValue.startsWith(' ') || crtValue.endsWith(' '))) { return { whitespace: true }; }
    if (crtValue) { crtValue = crtValue.trim(); }
    if (!crtValue) { return { required: true }; }
    return null;
  }

  static MatchValidator(sourceKey: string, targetKey: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const source = group.get(sourceKey);
      const target = group.get(targetKey);

      if (source && target) {
        const sourceVal = source.value;
        const targetVal = target.value;

        const errors = target.errors || {};

        // If values don't match → add notMatch
        if (sourceVal && targetVal && (sourceVal !== targetVal)) {
          target.setErrors({ ...errors, notMatch: true });
        }
      }

      return null; // no group-level error
    };
  }

  static noArabicOrSpaces(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const invalidPattern = /[\s\u0600-\u06FF]/;

    return invalidPattern.test(value) ? { noArabicOrSpaces: true } : null;
  }

  /**
   * Validator for a FormControl that checks for duplicates in its FormArray
   */
  static duplicateControl(control: AbstractControl): ValidationErrors | null {
    if (!control || !control.parent) return null;

    const parent = control.parent;

    // Only works if parent is a FormArray
    if (!(parent instanceof FormArray)) return null;

    const value = (control.value || '').toString().trim().toLowerCase();
    if (!value) return null;

    // Count occurrences of this value in the FormArray
    const occurrences = parent.controls.filter(c =>
      (c.value || '').toString().trim().toLowerCase() === value
    ).length;

    return occurrences > 1 ? { duplicate: true } : null;
  }
}
